<template>
  <div>
    <!-- 搜索表单 -->
    <el-form :model="table.where" label-width="77px" class="ele-form-search" @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
      <el-row :gutter="15">
        <el-col :md="24" :sm="12">
          <el-form-item label="学生姓名:">
            <el-input v-model.trim="table.where.studentName" placeholder="请输入学生姓名" clearable style="width: 200px" />
          </el-form-item>
        </el-col>
        <el-col :lg="6" :md="7" :sm="12">
          <el-form-item label="日期:">
            <el-date-picker
              v-model="date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              @change="handleDateChange"
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :lg="3" :md="6" :sm="12">
          <el-form-item label="学部:">
            <el-select v-model="table.where.branchId" placeholder="请选择学部" style="width: 140px" @change="handleChange($event, 2)" clearable>
              <el-option v-for="item in branchList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="3" :md="6" :sm="12">
          <el-form-item label="年级:">
            <el-select v-model="table.where.gradeId" placeholder="请选择年级" style="width: 140px" @change="handleChange($event, 3)" clearable>
              <el-option v-for="item in gradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="3" :md="6" :sm="12">
          <el-form-item label="级部:">
            <el-select v-model="table.where.gradeItemId" placeholder="请选择级部" style="width: 140px" @change="handleChange($event, 4)" clearable>
              <el-option v-for="item in subGradeList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="7" :sm="12">
          <el-form-item label="班级:">
            <el-select v-model="table.where.classId" placeholder="请选择班级" style="width: 140px" clearable @change="$forceUpdate()">
              <el-option v-for="item in classList" :key="item.id" :label="item.name" :value="item.id" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="4" :md="6" :sm="12">
          <div class="ele-form-actions">
            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search" class="ele-btn-icon">查询</el-button>
            <el-button @click="(table.where = { type: 1 }) && $refs.table.reload()">重置</el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <!-- 操作按钮 -->
    <div class="ele-table-tool ele-table-tool-default">
      <el-button @click="exportData" type="primary" icon="el-icon-download" class="ele-btn-icon" size="small">导出</el-button>
    </div>
    <ele-data-table ref="table" :config="table" :choose.sync="choose" row-class-name="custom-row-class" highlight-current-row>
      <template>
        <el-table-column type="selection" width="45" align="center" />
        <el-table-column type="index" width="45" align="center" />
        <el-table-column prop="studentName" label="姓名" show-overflow-tooltip align="center" />
        <el-table-column prop="studentNumber" label="学号" show-overflow-tooltip align="center" />
        <el-table-column prop="branchName" label="学部" show-overflow-tooltip align="center" />
        <el-table-column prop="gradeName" label="年级" show-overflow-tooltip align="center" />
        <el-table-column prop="gradeItemName" label="级部" show-overflow-tooltip align="center" />
        <el-table-column prop="className" label="班级" show-overflow-tooltip align="center" />
        <el-table-column prop="score" label="得分" show-overflow-tooltip align="center" />
      </template>
    </ele-data-table>
  </div>
</template>

<script>
  import { exportAccessStatistics, selectionList } from '@/config/fengyi/examine';

  export default {
    name: 'Personal',
    data() {
      return {
        table: {
          // 表格配置
          url: '/fyAccess/getAccessStatisticsPage',
          method: 'GET',
          where: {
            type: 1,
          },
          parseData(res) {
            if (res.resCode == 200) res.code = 0;
            res.count = res.data.total;
            res.data = res.data.records;
            return res;
          },
        },
        choose: [],
        branchList: [],
        gradeList: [],
        subGradeList: [],
        classList: [],
        date: null,
      };
    },
    created() {
      this.searchListbyType(1);
    },
    methods: {
      // 搜索下拉选
      searchListbyType(type, id) {
        let data = {
          type: type,
          id: id,
        };
        selectionList(data).then((res) => {
          if (res.data.resCode == 200) {
            if (type == 1) {
              //校部
              this.branchList = res.data.data;
            } else if (type == 2) {
              //年级
              this.gradeList = res.data.data;
            } else if (type == 3) {
              //级部
              this.subGradeList = res.data.data;
            } else if (type == 4) {
              //班级
              this.classList = res.data.data;
            }
          }
        });
      },
      // 搜索下拉框值变化
      handleChange(value, type) {
        if (type == 2) {
          this.gradeList = [];
          this.subGradeList = [];
          this.classList = [];
          this.table.where.gradeId = null;
          this.table.where.gradeItemId = null;
          this.table.where.classId = null;
        } else if (type == 3) {
          this.subGradeList = [];
          this.classList = [];
          this.table.where.gradeItemId = null;
          this.table.where.classId = null;
        } else if (type == 4) {
          this.classList = [];
          this.table.where.classId = null;
        }
        this.searchListbyType(type, value);
      },
      handleDateChange(value) {
        this.table.where.startDay = value[0];
        this.table.where.endDay = value[1];
      },
      // 导出
      exportData() {
        exportAccessStatistics(this.table.where).then((res) => {
          let blob = new Blob([res.data], {
            type: 'application/octet-stream',
          });
          let objectUrl = URL.createObjectURL(blob);
          let link = document.createElement('a');
          link.style.display = 'none';
          link.href = objectUrl;
          let filename = window.decodeURI(res.headers['content-disposition'].split('=')[1], 'UTF-8');
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link); // 下载完成移除元素
          window.URL.revokeObjectURL(objectUrl); // 释放掉blob对象
        });
      },
    },
  };
</script>

<style scoped></style>
